import { connect } from 'react-redux';
import  GoogleAnalyticsView from './GoogleAnalyticsView.jsx'
import { fetchIntegrations, getIntegrationForType } from "src/legacy/redux/actions/integrations.jsx";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'google_analytics');
  return {
    'integration': integration,
    integrations: state.legacyRootReducer.settings.integrations,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
  }
}

const GoogleAnalyticsPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(GoogleAnalyticsView);

export default withUseHooks(GoogleAnalyticsPage);